var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 38.0002H5.6C4.64522 38.0002 3.72955 37.6209 3.05442 36.9458C2.37928 36.2706 2 35.355 2 34.4002V9.2002",
    stroke: "#6F42C1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0002 21.8033L35.6674 19.4705C34.8539 18.6571 33.7506 18.2002 32.6002 18.2002C31.4498 18.2002 30.3465 18.6571 29.533 19.4705L18.2002 30.8033",
    stroke: "#6F42C1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 16.4002C21.9886 16.4002 23.6004 14.7884 23.6004 12.8002C23.6004 10.812 21.9886 9.2002 20.0004 9.2002C18.0122 9.2002 16.4004 10.812 16.4004 12.8002C16.4004 14.7884 18.0122 16.4002 20.0004 16.4002Z",
    stroke: "#6F42C1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4002 2H12.8002C10.812 2 9.2002 3.61177 9.2002 5.6V27.2C9.2002 29.1882 10.812 30.8 12.8002 30.8H34.4002C36.3884 30.8 38.0002 29.1882 38.0002 27.2V5.6C38.0002 3.61177 36.3884 2 34.4002 2Z",
    stroke: "#6F42C1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGallery);
export default __webpack_public_path__ + "static/media/imageGallery.59a3103b5e74a8e5fca939860c69cef3.svg";
export { ForwardRef as ReactComponent };